module.exports = __webpack_public_path__ + "img/bmw.649c9815.png";